import React from 'react'
import { NextPage } from 'next'
import { PageContainer, Columns, Column } from 'components/base/grid/grid'
import StandardHero from 'components/hero/standardHero'
import SignupForm from 'components/forms/signupForm'
import { BasicPageWrapper } from 'components/base/sections/pageWrappers'
import styled from 'styled-components'
import NotACustomer from 'components/forms/notACustomer/notACustomer'
import { createClient } from 'prismicConfiguration'
import { SignupPage } from 'interfaces/prismic/signupPage'
// @ts-ignore
import { RichText } from 'prismic-reactjs'

const StyledBorder = styled.div`
	height: 100%;
	width: 1px;
	background-color: ${({ theme }) => theme.colors.borderColor};
`

interface Props {
	page: SignupPage
}

const Nyskraning: NextPage<Props> = ({ page }) => {
	const {
		hero_image,
		title,
		existing_customer_title,
		existing_customer_text,
		new_customer_title,
		new_customer_text,
		success_title,
		success_text,
	} = page.data

	return (
		<>
			<StandardHero imageOnMobile title={RichText.asText(title || [])} image={hero_image?.url ?? ''} short />
			<BasicPageWrapper>
				<PageContainer>
					<Columns>
						<Column desktopSmall={5.5 / 12}>
							<SignupForm
								title={existing_customer_title}
								text={existing_customer_text}
								successTitle={success_title}
								successText={success_text}
							/>
						</Column>
						<Column desktopSmall={1 / 12} />
						<Column desktopSmall={0.5 / 12}>
							<StyledBorder />
						</Column>
						<Column desktopSmall={5 / 12}>
							<NotACustomer title={new_customer_title} text={new_customer_text} />
						</Column>
					</Columns>
				</PageContainer>
			</BasicPageWrapper>
		</>
	)
}

Nyskraning.getInitialProps = async () => {
	const client = createClient()
	const page = await client.getSingle<SignupPage>('sign-up_page', {})

	return {
		page,
		label: 'Nýskráning',
	}
}

export default Nyskraning
